import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-pta-global',
  standalone: false,
  templateUrl: './pta-global.component.html',
  styleUrl: './pta-global.component.scss'
})
export class PtaGlobalComponent {

  annee: any;
  items: any = [] = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any = [];
  user: any;
  directionItems: any = [];
  directionId: any;
  isLoading: boolean = false;

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

  }
  selectedActivite: any = null;
  @ViewChild('detailModal') modalContent: TemplateRef<any>;

  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
    //console.log("  this.user", this.user);
    this.directionId = this.user?.service?.direction?.reference,
      this.getStatistique();
    this.getDirection();
  }
  getStatistique() {
    this.ngxService.start();
    const requestData = {
      annee: this.annee,
      dirdection_id: this.directionId,
      user_reference: this.user.reference,
      type_operation: "data"
    }
    this.paramservice.getStatistiquePtaGlobal(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        // this.isLoading = false;
        this.items = response.data;
         this.totalRecords = this.items.length;
        this.updatePaginatedProjets();
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
        //this.isLoading = false;
      }
    );
  }
  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.items.slice(start, end);
  }//end updatePaginatedProjets
  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(

      (response: any) => {

        ////console.log("la reponse du webservice", response);

        this.directionItems = response.data;

      },
      (error) => {

        ////console.log("une erreur est survenu", error);

      }
    )
  }

  exportToDocument(typeDoc: any) {
    const requestData = {
      annee: this.annee,
      dirdection_id: this.directionId,
      user_reference: this.user.reference,
      type_operation:typeDoc
    }
    this.ngxService.start();


    this.paramservice.printStatistiqueGlobalPta(requestData).subscribe(
      (response: Blob) => {
        const filename = 'Statistiques_pta_global.pdf';
        FileSaver.saveAs(response, filename);

        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: 'Le fichier PDF a été téléchargé avec succès', life: 3000 });
      },
      (error) => {
        //console.error("Une erreur est survenue", error);
        this.ngxService.stop();
      }
    );

  }
  openTachesModal(activite: any) {
    this.selectedActivite = activite;
    //console.log(" this.selectedActivite ", this.selectedActivite );
    
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }

  close(){
    this.modalService.dismissAll()
  }

}
